import { apiClient } from '@/services/ApiClient.js'

export class ServiceErrorService {
  getServiceErrors(query) {
    return apiClient
      .get('service-errors', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  getServiceError(serviceError) {
    return apiClient
      .get('service-errors/' + serviceError)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
  markAsFixed(serviceError) {
    return apiClient
      .patch('service-errors/' + serviceError + '/mark-as-fixed')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
  unmarkAsFixed(serviceError) {
    return apiClient
      .patch('service-errors/' + serviceError + '/unmark-as-fixed')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
